
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import { Customer } from '../../global/models'
import { prettyDateTime } from '@/domains/global/functions/util'

@Component({
  components: { ListComponent }
})
export default class CustomerList extends Vue {
  get filterOptions() {
    return [
      { text: 'ID', key: 'id', type: 'number' },
      { text: 'Given Name', key: 'givenName', type: 'string' },
      { text: 'Surname', key: 'surname', type: 'string' },
      { text: 'Email', key: 'email', type: 'string' }
    ]
  }

  get availableColumns() {
    return [
      { text: 'Given Name', value: 'givenName' },
      { text: 'Surname', value: 'surname' },
      { text: 'Email', value: 'email' },
      { text: 'Mobile', value: 'mobile' },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get defaultColumns() {
    return ['givenName', 'surname', 'email', 'created', 'updated']
  }
  
  get actions() {
    return [
      { text: 'View', method: (customer: Customer) => this.viewCustomer(customer) }
    ]
  }

  get list() {
    return this.$refs.list as ListComponent<Customer>
  }

  viewCustomer(customer: Customer) {
    this.$router.push({ name: 'customers-read', params: { id: customer.id.toString() } })
  }
}
